// @flow
import React, { PureComponent, Fragment } from 'react';

import Breadcrumb from 'components/fragments/Breadcrumb';
import ContactAndFaqSelector from 'containers/contact/ContactAndFaqSelectorContainer';
import ContactList from 'containers/contact/ContactListContainer';
import ContactDetails from 'containers/contact/ContactDetailsContainer';
import ContactForm from 'containers/contact/ContactFormContainer';
import ContactThumbnailsBlock from 'containers/contact/ContactThumbnailsBlockContainer';
import { withHelmet } from 'infrastructure/seo/Helmet';
import type { ThemeType } from 'types/Faq';
import { getMetaBySlug } from 'utils/seoUtils';

import './contact.css';

export type StateProps = {
  faqThemes?: Array<ThemeType>
};

export type DispatchProps = {
  fetchThemes: () => void,
  fetchQuestions: () => void
};

type Props = {
  location: {
    search: string
  },
  match: {
    params: {
      slugTheme: string
    }
  }
} & DispatchProps &
  StateProps;

class ContactWrapper extends PureComponent<Props> {
  static defaultProps = {
    faqThemes: []
  };

  componentDidMount() {
    this.props.fetchThemes();
    this.props.fetchQuestions();
  }

  render() {
    const {
      faqThemes,
      match: {
        params: { slugTheme }
      }
    } = this.props;

    return (
      <Fragment>
        <section className="banner banner--big banner--center">
          <div className="banner__thumbnail img-blue-100" style={{ backgroundImage: 'url()' }} />
          <div className="container">
            <Breadcrumb breadcrumbStyle="mt-3" elements={[{ name: 'Accueil', to: '/' }, 'Contact']} isDark={true} />
            <h1 className="ft-h2">Contact</h1>
            <p className="banner__desc">
              La ligue se tient à votre disposition pour répondre à toutes vos questions. <br />À quel sujet
              pouvons-nous vous aider ?
            </p>
          </div>
        </section>
        <div className="container">
          <div className="row">
            <div className="col col-lg-8 col-lg-offset-2">
              <ContactAndFaqSelector faqThemes={faqThemes} slug={slugTheme} />
            </div>
          </div>

          <div className="row mb-lg-8 mb-4">
            <div className="col col-lg-8 col-lg-offset-2">
              <div className="box block-contact mt-5">
                {slugTheme !== 'nous-contacter' ? <ContactList /> : <ContactForm />}
                <ContactDetails />
              </div>
            </div>
          </div>

          <div className="row mb-6 mb-md-7 mb-lg-8 mt-8">
            <ContactThumbnailsBlock />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withHelmet(ContactWrapper)((Helmet, pageProps) => {
  const meta = getMetaBySlug(pageProps.location.pathname);
  return (
    <Helmet>
      <title>{meta.title()}</title>
      <meta name={'description'} content={meta.description()} />
      <link rel={'canonical'} href={window.location.href} />
      <meta property={'og:title'} content={meta.title()} />
      <meta property={'og:description'} content={meta.description()} />
    </Helmet>
  );
});
